import store from '@/store'
import Configuration from '@/utils/configuration'
import AWS from 'aws-sdk'
import NotificationService from '@/services/NotificationService'

export default new class AWSService {
  putObjectRequests = [];
  notificationBox = null;
  internetConnectionTotalFailedInRow = 0;
  internetConnectionTotalSuccessInRow = 0;

  configureAWS (store) {
    const httpRequestTimeoutInMilliseconds = 1000 * 60 * 60
    this.store = store
    AWS.config.region = Configuration.value('aws_identity_region')
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: Configuration.value('aws_identity_pool_id')
    })
    AWS.config.update({ httpOptions: { timeout: httpRequestTimeoutInMilliseconds } })
  }

  getS3FileUrl (fileName) {
    const bucketName = Configuration.value('aws_s3_bucket_name')
    const bucketRegion = Configuration.value('aws_s3_bucket_region')
    const userEmail = store.getters['cpAuth/currentUser'].user.email

    return 'https://s3-' + bucketRegion + '.amazonaws.com/' + bucketName + '/' + userEmail + '/' + fileName
  }

  uploadFile (file, fileName) {
    const awsS3 = new AWS.S3({
      params: {
        Bucket: Configuration.value('aws_s3_bucket_name')
      }
    })

    return new Promise((resolve, reject) => {
      if (file) {
        const userEmail = store.getters['cpAuth/currentUser'].user.email
        const objKey = userEmail + '/' + fileName
        const params = {
          Key: objKey,
          ContentType: file.type,
          Body: file,
          ACL: 'public-read'
        }

        let currentProgressPercentage = 0
        let lastLoadedProgressInBytes = 0
        let putObjectRequest = awsS3.putObject(params)
          .on('httpUploadProgress', progress => {
            let currentPercentage = (progress.loaded * 100) / progress.total
            let increasePercentage = currentPercentage - currentProgressPercentage
            currentProgressPercentage = currentPercentage
            this.store.dispatch('progress/updateProgress', increasePercentage)

            // Handle slow internet connection
            this.handleSlowInternetConnection(progress, lastLoadedProgressInBytes)
            lastLoadedProgressInBytes = progress.loaded
          })
          .on('complete', () => {
            this.closeNotificationBlock()
          })
          .send((err, data) => {
            if (err) {
              reject(err)
            } else {
              resolve(data)
            }
          })

        this.putObjectRequests.push(putObjectRequest)
      } else {
        reject(new Error('Nothing to upload'))
      }
    })
  }

  handleSlowInternetConnection (progressObject, lastLoadedProgressInBytes) {
    if (!lastLoadedProgressInBytes) {
      return false
    }

    let progressInBytes = progressObject.loaded - lastLoadedProgressInBytes

    if (progressInBytes < 65000) {
      this.internetConnectionTotalFailedInRow++
      this.internetConnectionTotalSuccessInRow = 0
      if (!this.notificationBox && this.internetConnectionTotalFailedInRow >= 5) {
        this.notificationBox = NotificationService.messageIndefinite('Your internet connection is slow. The uploading may be longer.')
      }
    } else {
      this.internetConnectionTotalSuccessInRow++
      if (this.internetConnectionTotalSuccessInRow >= 5) {
        this.closeNotificationBlock()
      }
    }
  }

  closeNotificationBlock () {
    NotificationService.close(this.notificationBox)
    this.notificationBox = null
    this.internetConnectionTotalFailedInRow = 0
    this.internetConnectionTotalSuccessInRow = 0
  };

  abortUploading () {
    for (let putObjectRequest of this.putObjectRequests) {
      putObjectRequest.request.abort()
    }

    this.closeNotificationBlock()
  }
}()
